<div class="split tw:flex tw:w-full">
  <div class="full-width tw:w-full content tw:min-w-0 tw:overflow-y-auto">
    <div class="mobile">
      <ng-content select="[contentMobile]"></ng-content>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="desktop">
    <app-quick-links-card>
      <ng-content select="[contentEnd]"></ng-content>
    </app-quick-links-card>
  </div>
</div>
